import MainLayout from "layouts/MainLayout/MainLayout";
import DashboardPage from "pages/DashboardPage/Dashboard";

import Error404 from "pages/Error404/Error404";
import SignInPage from "pages/SingInPage/SignIn";
import Orders from "pages/OrderPage/OrderPage";
import PrivateRoute from "Components/shared/PrivateRoute";
import { Navigate } from "react-router-dom";
import OrderDetailsPage from "pages/OrderDetailsPage/OrderDetailsPage";
import DriversRequests from "pages/DriversRequestsPage/DriversRequestsPage";
import DriversRequestsInformations from "pages/DriversRequestsInformationPage/DriversRequestsInformations";
import CustomerManagement from "pages/CustomerManagementPage/CustomerManagement";
import CustomerDetails from "Components/CustomerManagement/CustomerDetails";
import DispatchPageWrapper from "Components/Dispatcher/DispatchPageWrapper";
import PushNotification from "Components/Push Notification/PushNotification";
import DriverManagement from "pages/DriverManagement/DriverManagement";
import DriverDetails from "Components/DriverManagement/DriverDetails";
import DriversMapLocations from "pages/DriversMapLocations/DriversMapLocations";
import ExpeditedTracking from "pages/ExpeditedTracking/ExpeditedTracking";
import DeliveryPricingPage from "pages/DeliveryPricing/DeliveryPricingPage";
import WalletTransactionPage from "pages/WalletTransaction/WalletTransactionPage";
import CashOutRequestPage from "pages/CashOutRequest/CashOutRequestPage";
import WalletsPage from "pages/WalletsPage/WalletsPage";
import CashOutRulePage from "pages/CashOutRulePage/CashOutRulePage";

export const appRoutes = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },

      {
        path: "orders",
        element: (
          <PrivateRoute>
            <Orders />
          </PrivateRoute>
        ),
      },
      {
        path: "orders/:orderId",
        element: (
          <PrivateRoute>
            <OrderDetailsPage />
          </PrivateRoute>
        ),
      },
      {
        path: "orders/:orderId/dispatch",
        element: (
          <PrivateRoute>
            <DispatchPageWrapper />
          </PrivateRoute>
        ),
      },
      {
        path: "driversRequests",
        element: (
          <PrivateRoute>
            <DriversRequests />
          </PrivateRoute>
        ),
      },
      {
        path: "drivers-requests/:driverRequestId",
        element: (
          <PrivateRoute>
            <DriversRequestsInformations />
          </PrivateRoute>
        ),
      },
      {
        path: "dashboard",
        element: (
          <PrivateRoute>
            <DashboardPage />
          </PrivateRoute>
        ),
      },
      {
        path: "customerManagement",
        element: (
          <PrivateRoute>
            <CustomerManagement />
          </PrivateRoute>
        ),
      },
      {
        path: "/customerManagement/CustomerDetails/:senderId",
        element: (
          <PrivateRoute>
            <CustomerDetails />
          </PrivateRoute>
        ),
      },
      {
        path: "pushNotification",
        element: (
          <PrivateRoute>
            <PushNotification />
          </PrivateRoute>
        ),
      },
      {
        path: "driverManagement",
        element: (
          <PrivateRoute>
            <DriverManagement />
          </PrivateRoute>
        ),
      },
      {
        path: "orders/expedited",
        element: (
          <PrivateRoute>
            <ExpeditedTracking />
          </PrivateRoute>
        ),
      },
      {
        path: "delivery-pricing",
        element: (
          <PrivateRoute>
            <DeliveryPricingPage />
          </PrivateRoute>
        ),
      },
      {
        path: "delivery-pricing/:orderType",
        element: (
          <PrivateRoute>
            <DeliveryPricingPage />
          </PrivateRoute>
        ),
      },
      {
        path: "wallet-transactions",
        element: (
          <PrivateRoute>
            <WalletTransactionPage />
          </PrivateRoute>
        ),
      },
      {
        path: "cash-out-requests",
        element: (
          <PrivateRoute>
            <CashOutRequestPage />
          </PrivateRoute>
        ),
      },
      {
        path: "wallets",
        element: (
          <PrivateRoute>
            <WalletsPage />
          </PrivateRoute>
        ),
      },
      {
        path: "cash-out-rule",
        element: (
          <PrivateRoute>
            <CashOutRulePage />
          </PrivateRoute>
        ),
      },
      {
        path: "/driverManagement/DriverDetails/:driverId",
        element: (
          <PrivateRoute>
            <DriverDetails />
          </PrivateRoute>
        ),
      },
      {
        path: "driverManagement/locations",
        element: (
          <PrivateRoute>
            <DriversMapLocations />
          </PrivateRoute>
        ),
      },
    ],
  },

  // Standalone routes
  { path: "/sign-in", element: <SignInPage /> },
  { path: "*", element: <Error404 /> },
];
